import { render, staticRenderFns } from "./CheckBoxInput.vue?vue&type=template&id=708c278e&scoped=true&"
import script from "./CheckBoxInput.vue?vue&type=script&lang=js&"
export * from "./CheckBoxInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c278e",
  null
  
)

export default component.exports